<template>
  <div class="list">
    <div class="content-wrapper">
      <div class="filter-wrapper">
        <div class="switch-wrapper">
          筛选班级：
          <el-radio-group v-model="isFinish" @change="changeSwitch">
            <el-radio :label="0">未完结</el-radio>
            <el-radio :label="1">已完结</el-radio>
          </el-radio-group>
        </div>
      </div>
      <table class="table" v-if="!isEmpty(staticList)">
        <tr class="order-brief">
          <th class="black">
            班级名称-老师
          </th>
          <th class="border">
            结束时长/班级总时长(min)
          </th>
          <th class="border">
            收入/预估总收入(元)
          </th>
          <th class="border">
            学员名单
          </th>
          <th>
            操作
          </th>
        </tr>
        <template v-for="(item,index) in staticList">
          <tr class="order-brief">
            <td>
              {{decodeURIComponent(item.classname)}}-{{decodeURIComponent(item.username)}}
            </td>
            <td>
              {{decodeURIComponent(item.finishedclasshour)}} / {{decodeURIComponent(item.classhour)}}
            </td>
            <td>{{decodeURIComponent(item.gotincome)}} / {{decodeURIComponent(item.estimateincome)}}</td>
            <td>
              <template v-for="(item2) in item.studentname">
                <span>{{decodeURIComponent(item2.username)}} </span>
              </template>
            </td>
            <td style="cursor:pointer">
              <router-link target="_blank" :to="'/console/statistic/info/'+item.classid">
                课时详情
              </router-link>
            </td>
          </tr>
        </template>
      </table>
      <template v-if="!isEmpty(staticList)&&totalPage>10">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
          :page-size="10"
          :total="totalPage">
        </el-pagination>
      </template>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';

  export default {
    data() {
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        currentPage: 1,
        totalPage: 1,
        staticList: [],
        isFinish: 0,
      }
    },
    methods: {
      isEmpty(obj) {
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      changeSwitch() {
        this.staticList = [];
        this.currentPage = 1;
        this.QueryRoomClassSettlement(1);
      },
      handleCurrentChange(val){
        this.QueryRoomClassSettlement(val)
      },
      QueryRoomClassSettlement(pageNumber) {
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'ClassHour',
            a: 'QueryRoomClassSettlement',
            id: this.id,
            rid: this.schoolNow.rid,
            isfinish: this.isFinish,
            pageno: pageNumber,
            pagesize: 10,
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path: '/log', query: {url: this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.totalPage = Number(response.recordcount);
            this.staticList = response.list;
          }
        }).catch((err) => {
        })
      }
    },

    created() {
      this.QueryRoomClassSettlement(1);
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .list
    width: 100%
    height: 100%
    background: #f2f2f2
    font-size: 0
    overflow auto
    .content-wrapper
      margin: 111px 20px 20px 180px
      width: 1166px
      .filter-wrapper
        margin-bottom: 20px
        padding-left: 10px
        height: 60px
        width: 100%
        font-size: 0
        background #fff
        box-sizing border-box
        .switch-wrapper
          float: left
          margin: 20px
          font-size: 16px
          color: #000000
      .no-result
        font-size: 18px
        color: #333
        text-align: center
      .table
        width: 1164px
        background: #ffffff
        text-align: center
        font-size: 0
        table-layout: fixed
        .order-brief
          border-bottom: 1px solid #e4e4e4
          &:last-child
            border: none
          th
            height: 40px
            line-height: 40px
            width: 194px
            font-size: 14px
            color: #999
            box-sizing: border-box
            &:first-child
              width: 244px
              border-right: 1px solid #e4e4e4
            &:last-child
              width: 144px
            &.black
              color: #000
            &.border
              position: relative
              &::after
                content: ''
                position: absolute
                top: 10px
                right: 0
                width: 0
                height: 20px
                border-right: 1px solid #e4e4e4

          td
            height: 50px
            line-height: 50px
            font-size: 14px
            color: #333
            overflow: hidden
            text-overflow: ellipsis
            white-space: nowrap
            box-sizing: border-box
            a
              color:#333


</style>
<style lang="stylus" rel="stylesheet/stylus">
  .self-message
    .el-message-box__message p
      word-break: break-all
</style>



// WEBPACK FOOTER //
// src/page/statistic/staticlist/staticlist.vue